import { LeagueMode, Member, LeaderboardCtx } from "./types";

export function memberHref(m: Member, ctx: Pick<LeaderboardCtx, "leagueId" | "myMemberId" | "mode" | "isStarted">): string {
  const { leagueId, myMemberId, mode } = ctx;
  const isMe = m.id === myMemberId;

  switch (mode) {
    case "GAMEWEEK_CHALLENGE":
      return isMe
        ? `/leagues/${leagueId}/challenge`
        : `/leagues/${leagueId}/challenge/member/${m.id}`;
    case "FINAL_POSITIONS":
      return `/leagues/${leagueId}/teams/${m.id}`;
    case "SCORE_PREDICTOR":
      return isMe
        ? `/leagues/${leagueId}/score-predictor`
        : `/leagues/${leagueId}/score-predictor/member/${m.id}`;
    case "SYNDICATE":
      if (isMe) return `/leagues/${leagueId}/syndicate`;
      // Always route to the member view — picks stay hidden server-side until
      // the league starts (same as TARGET/GWC/FINAL_POSITIONS), and the page
      // itself shows a "not visible yet" notice instead of bouncing back.
      return `/leagues/${leagueId}/syndicate/member/${m.id}`;
    default:
      return `/leagues/${leagueId}/teams/${m.id}`;
  }
}

/** Derives the "my team" link for the current user — null for modes with no personal view. */
export function myTeamHref(
  mode: LeagueMode,
  myMemberId: string | null,
  leagueId: string,
  isStarted: boolean,
): string | null {
  if (!myMemberId) return null;
  const fakeMember = { id: myMemberId } as Member;
  return memberHref(fakeMember, { leagueId, myMemberId, mode, isStarted });
}
